import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { TransactionStateName } from '@frontend/transaction/types';
import React from 'react';

import useTransactionStateSelect from './transaction-state-select.controller';

const ID = 'transaction-state-select';
export interface TransactionStateSelectV2Props extends Omit<SelectInputV2Props<TransactionStateName>, 'options'> {
    subset?: string[];
}

export const TransactionStateSelectV2 = (props: TransactionStateSelectV2Props) => {
    const viewProps = useTransactionStateSelect(props);
    return (
        <SelectInputV2<TransactionStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Transaction state'}
            options={viewProps.options}
        />
    );
};
